// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"63":"21bba2a3ae2245a7","405":"6f156f41c31472c4","615":"5952fab8ad68f776","888":"e9df7d71c6cc6030"}[chunkId] + ".css";
};